module.exports = __webpack_public_path__ + "static/img/oppoK5.60aa80ef.png";